@import "../../../../../shared/styles/base";

.status-tag {
  position: relative;
  padding: 0 0 0 1.5em;
  display: block;

  &::before {
    position: absolute;
    content: "";
    display: block;
    width: 1em;
    height: 1em;
    border-radius: 0.5em;
    left: 0;
    top: 0.25em;
  }

  &--awaiting-assignment::before {
    background: $ds-coral-500;
  }

  &--assigned::before {
    background: $ds-mustard-500;
  }

  &--accepted::before {
    background: $ds-jade-500;
  }

  &--closed::before {
    background: $ds-teal-500;
  }

  &--archived::before {
    background: $ds-violet-500;
  }
}
